import { render, staticRenderFns } from "./JudgeDel.vue?vue&type=template&id=3a40fdab&lang=pug&"
import script from "./JudgeDel.vue?vue&type=script&lang=js&"
export * from "./JudgeDel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports